import { useContext, useMemo } from 'react';
import { DocumentLightningRegular } from '@fluentui/react-icons';

import { TOverflowButtonParam } from '@shared/components';
import { SignInContext } from '@modules/users';

import { isContentAutomationVisible } from '../helpers';
import useContentAutomationStore from '../stores/useContentAutomationStore';

const useContentAutomationNavAction = () => {
  const { organization } = useContext(SignInContext);
  const open = useContentAutomationStore((state) => state.open);
  const contentAutomation = organization.mock?.contentAutomation;
  const isVisible = isContentAutomationVisible(contentAutomation);

  const contentAutomationNavActionButton = useMemo<TOverflowButtonParam | undefined>(() => {
    if (!isVisible) return undefined;

    return {
      children: 'Automate content',
      icon: <DocumentLightningRegular />,
      onClick: open,
    };
  }, [isVisible, open]);

  return {
    contentAutomationConfig: contentAutomation,
    contentAutomationNavActionButton,
  };
};

export default useContentAutomationNavAction;
